$(document).ready(function()
{

    $(".slick-standard").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $(".slick-simple").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    

    $(".slick-featured").slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        fade: true,
        cssEase: 'linear'
        
    });

    $(".slick-story").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        //fade: true,
        //cssEase: 'linear'
    });


    $(".slick-content-cycle").slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 7500,
        pauseOnHover:true,
    });


    $(".slick-advert").slick({
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 1.65,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '85px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });

    $(".slick-centered").slick({

        arrows: true,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                }
            }

        ]

    });

    $('.slick-thumbs-top').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        centerMode: true,
        asNavFor: '.slick-thumbs-bottom'
    });

    $('.slick-thumbs-bottom').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slick-thumbs-top',
        dots: false,
        arrows: true,
        centerMode: true,
        focusOnSelect: true

    });

    $(".slick-cards").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,

                }
            }
        ]

    });

    $(".slick-blog").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,

                }
            }
        ]

    });

    var cards = $('.slick-cards .col');
    var maxHeight = 0;

    if (cards)
    {

        window.setTimeout(function(){ 

            // Loop all cards and check height, if bigger than max then save it
            for (var i = 0; i < cards.length; i++) 
            {
                if (maxHeight < $(cards[i]).outerHeight()) 
                {
                    maxHeight = $(cards[i]).outerHeight();
                }
            }
            // Set ALL card bodies to this height
            for (var i = 0; i < cards.length; i++) 
            {
                $(cards[i]).height(maxHeight);
            }

        }, 500 );
    }

    var blogs = $('.slick-blog .col');
    var maxHeight = 0;

    if (blogs)
    {

        window.setTimeout(function(){ 

            // Loop all blogs and check height, if bigger than max then save it
            for (var i = 0; i < blogs.length; i++) 
            {
                if (maxHeight < $(blogs[i]).outerHeight()) 
                {
                    maxHeight = $(blogs[i]).outerHeight();
                }
            }
            // Set ALL card bodies to this height
            for (var i = 0; i < blogs.length; i++) 
            {
                $(blogs[i]).height(maxHeight);
            }

        }, 500 );
    }



    var slider_speed = 4500;

    if ($(".js-slick").length) 
    {

        $(".js-slick").not('.slick-initialized').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            fade: true,
            cssEase: 'linear'
        });

        if ($(".js-slick").data('timer')) 
        {
            slider_speed = $(".js-slick").data('timer');
        }

        $(".js-slick").slick('slickSetOption', 'autoplaySpeed', slider_speed);   
    }

    if ($(".js-slick-no-nav").length) 
    {

        $(".js-slick-no-nav").not('.slick-initialized').slick({
            dots: false,
            arrows: false,
            autoplay: true,
            fade: true,
            cssEase: 'linear'
        });

        if ($(".js-slick-no-nav").data('timer')) 
        {
            slider_speed = $(".js-slick-no-nav").data('timer');
        }
        $(".js-slick-no-nav").slick('slickSetOption', 'autoplaySpeed', slider_speed);   
    }


    if ($('.yt-bg-video').length)
    {
        $('.yt-bg-video').youtube_background();
    }




});
 
// slick changes on resize
$(window).on('load resize orientationchange', function() 
{
    $('.slick-on-small').each(function(){
        var $carousel = $(this);

        if ($(window).width() > 640) 
        {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else
        {
            if (!$carousel.hasClass('slick-initialized')) 
            {
                $carousel.slick({
                  dots: true,
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false,
                  //autoplay: true,
                  pauseOnHover:true,
                  pauseOnFocus: false,
                  autoplaySpeed: 5000,
                });
            }
        }
    });

});
